import { connect } from 'react-redux'
import {
  setSidebarFilter,
  setSidebarSection,
  resetSidebarFilter
} from '../../../store/actions/sidebar'
import {
  sidebarFilterSelector,
  sidebarSectionSelector
} from '../../../store/selectors/sidebarSelectors'
import { userSelector } from '../../../store/selectors/baseSelectors'

const SidebarFiltersContainer = connect(
  state => ({
    section: sidebarSectionSelector(state),
    filter: sidebarFilterSelector(state),
    user: userSelector(state)
  }),
  {
    setSection: setSidebarSection,
    setFilter: setSidebarFilter,
    resetFilter: resetSidebarFilter
  }
)

export default SidebarFiltersContainer
